import { useMemo } from 'react';
import { t } from '@lingui/core/macro';
import { ChevronDown, AlertCircle, X } from 'lucide-react';
import { Button, Menu, MenuButton, MenuItem, MenuList, Box } from '@chakra-ui/react';

import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { iconSize } from '@duke-hq/ui/constants/scalable';

const issueOptions = [
  {
    value: 'usi',
    label: 'USI Missing / Incorrect',
  },
  {
    value: 'recognition',
    label: 'CT / RPL requested',
  },
  {
    value: 'underage',
    label: '16 or under',
  },
];

export default function IssueFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const selectedIssue = useMemo(() => {
    const issue = issueOptions.find((issue) => issue.value === filters.issue);
    return issue ? issue.label : t`Issue`;
  }, [filters.issue]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="ghost"
        width="auto"
        colorScheme="gray"
        px={2}
        rightIcon={
          filters.issue !== undefined ? (
            <Box
              minW="fit-content"
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                updateFilters({ issue: undefined });
              }}
              ml={1}
            >
              <X size={iconSize.md} />
            </Box>
          ) : (
            <ChevronDown size={iconSize.md} />
          )
        }
        leftIcon={<AlertCircle size={iconSize.md} />}
      >
        {selectedIssue}
      </MenuButton>
      <MenuList>
        {issueOptions.map(({ value, label }) => (
          <MenuItem
            key={label}
            onClick={() => {
              updateFilters({ issue: value });
            }}
          >
            {label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
